"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import weeklyPeriodSelectsFactory from "./viewing-summary/weekly-period-selects";
import weeklyViewingSummary from "./viewing-summary/weekly-viewing-summary-new";
import tableFilter from "./common/table-filter";
import moreInfo from "./top-programmes/more-info";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "period_selects",
    weeklyPeriodSelectsFactory("/whats-new/viewing-summary-available-weeks-new")
);
core.createModule(
    "weekly_summary",
    weeklyViewingSummary("/whats-new/weekly-viewing-summary-new")
);
core.createModule("moreInfo", moreInfo);
core.createModule("table_filter", tableFilter);

core.startAll();
